import { z } from 'zod';

import { LocationSchema } from './LocationSchema';
import {
  validateCoordinates,
  validateCustomAddress,
  validateFias
} from './validation-helpers';

const externalIdRegex = /^[A-Za-z0-9._%+-]+$/;

const namesMessage = (lenght: number) => {
  return {
    message: `До ${lenght} символов`
  };
};

const assetForSelection = z.object({
  key: z.string().or(z.number()),
  label: z
    .string()
    .min(1, { message: 'Поле тип объекта обязательно для заполнения' })
});

const geographicalZoneForSelection = z
  .object({
    id: z.number(),
    label: z.string()
  })
  .nullable()
  .optional();

const BaseAssetSchema = z
  .object({
    id: z.number().or(z.string()),
    state: z.boolean(),
    name: z
      .string()
      .min(1, { message: 'Пожалуйста, укажите название объекта' })
      .max(100, namesMessage(100))
      .refine((value) => value.trim().length > 0, {
        message: 'Поле не может содержать только пробелы'
      }),
    externalId: z
      .string()
      .transform((value) => value.trim()) // Trim the input first
      .refine((value) => value.length === 0 || externalIdRegex.test(value), {
        message: 'Внешний № может содержать латинские буквы и цифры'
      })
      .optional(),
    type: assetForSelection,
    geographicalZone: geographicalZoneForSelection,
    description: z.string().max(200, namesMessage(200)),
    address: z.string().max(150, namesMessage(150)).optional()
    // parameters: z.array(TreeNodeSchema)
  })
  .merge(
    LocationSchema.omit({
      excludedStreetsFias: true,
      excludedHousesFias: true
    })
  );

export const AssetSchema = BaseAssetSchema.superRefine((data, ctx) => {
  validateFias(data, ctx);
  validateCustomAddress(data, ctx);
  validateCoordinates(data, ctx);
});
